















import { AuthStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import { Component, Emit, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { ChatbotMsg, ChatbotMsgsForConversationRes } from '../models/ChatbotMsg';
import LoadingIndicator from '../../core/components/LoadingIndicator.vue';
import { ColorsList, ID, TypeParams } from '../../../features/core/utils';
import { ChatbotServices } from '../api/ChatbotServices';
@Component({
    components: {
      LoadingIndicator
    }
})
export default class ChatbotPreviousMessages extends Mixins(
  RootStoreHelper,
  NotificationStoreHelper
) {
  @Prop({default: false}) currentConversationIsDisabled: boolean;
  @Prop({default: -1}) conversationId: ID;
  @Prop({default: false}) scrollIsOnTop: boolean;
  loadingTextColor: string = ColorsList.white;
  loadingColor: string = ColorsList.white;
  pendingPreviousMsgs: boolean = false;
  needToGetPreviousMsgs: boolean = true;
  showAlertNoMoreMsgs: boolean = false;
  alertInterval: any = null;

  @Watch('scrollIsOnTop', {immediate: true})
  onScrollIsOnTopChanged(value: boolean) {
    if(this.currentConversationIsDisabled) return

    if(value){
      if(!this.needToGetPreviousMsgs){
        this.toggleAlertNoMoreMsgs();
        return
      }
      this.getPreviousMessages();
    }
  }

  updateNeedToGetPreviousMsgs(value: boolean){
    this.needToGetPreviousMsgs = value;
  }

  updateIfNeedToGetMoreMsgs(hasMorePreviousMsgs: boolean){
    let existMoreMsgs = hasMorePreviousMsgs;
    this.changeScrollToFirstMsg(true);

    if(!existMoreMsgs){
      this.updateNeedToGetPreviousMsgs(false);
      this.toggleAlertNoMoreMsgs();
    }
  }

  toggleAlertNoMoreMsgs() {
    clearTimeout(this.alertInterval);

    this.showAlertNoMoreMsgs = true;

    this.alertInterval = setTimeout(() => {
      this.showAlertNoMoreMsgs = false;
    }, 3000);
  }

    getPreviousMessages(){
      //Consulto mensajes anteriores enviando como parametro el primer msg de la conversacion

      if(this.conversationId == -1 || !this.needToGetPreviousMsgs || this.currentConversationIsDisabled) return

      let beforeMsgId = this.$store.state.chatbotState.messages[this.conversationId][0].id;

      let config = {
        conversation_id: this.conversationId,
        [TypeParams.BEFORE_MESSAGE_ID]: beforeMsgId
      }

      this.pendingPreviousMsgs = true;
      this.$_chatbotPendingPreviousMsgsForConversation(this.conversationId);
      ChatbotServices.getMessagesForConversation(
        config
      ).then((res: ChatbotMsgsForConversationRes) => {
        let currentConversationMsgs = this.$store.state.chatbotState.messages[this.conversationId];
        let newPreviousMsgs = res.messages;
        
        this.updateIfNeedToGetMoreMsgs(res.has_more_previous_messages);
        
        if(newPreviousMsgs.length > 0){
          let allMsgs = [...newPreviousMsgs, ...currentConversationMsgs];
          this.$_chatbotSetMsgsForConversation({
            conversation_id: this.conversationId,
            messages: allMsgs
          });
          
        }
      }).catch((err) => {
        this.$_catchLoadingDialog({
            response: err.response.data || {},
            alternative_msg: 'Error al obtener mensajes anteriores'
        })
      }).finally(() => {
        this.$_chatbotPendingPreviousMsgsForConversation(this.conversationId)
        this.pendingPreviousMsgs = false;
      })
    }

    @Emit()
    changeScrollToFirstMsg(value) {}
   
}
